import useSWRImmutable from 'swr/immutable';

import { apiFetcher } from '../utils/fetchers';

/**
 * Retrieves the feedback document for a given game code using SWRImmutable.
 *
 * @param {string} feedbackCode - The unique identifier of the game.
 * @returns {Object} - An object containing the feedback document data, loading flag, and error flag.
 *   - data: The feedback document data retrieved from the API.
 *   - isLoading: A boolean flag indicating whether the data is currently being loaded.
 *   - isError: A boolean flag indicating whether an error occurred while retrieving the data.
 */
export const useFeedbackDocument = (feedbackCode: string) => {
  // load the feedback document. immutable as the document shouldn't change.
  const { data, isLoading, error } = useSWRImmutable(
    () => `feedbacks/${feedbackCode}/document/content`,
    apiFetcher,
    { suspense: true }
  );

  if (error) console.log(error);

  return {
    data,
    isLoading,
    isError: error
  };
};
